function createImageElement(fileUrl) {
  if (typeof fileUrl !== "string") return null;

  const extension = fileUrl.split(".").pop().toLowerCase();

  return extension === "jpeg" || extension === "jpg" || extension === "png";
}

export { createImageElement };
